import customAxios from "./axiosConfig";

const CostTypeGroupService = {
  list: function (params) {
    var api_url = window.Urls['cost-type-group-list']();
    return customAxios.get(api_url, { params: params });
  },
  getBalanceSheetGroup: function () {
    var api_url = window.Urls['cost-type-group-get-balance-sheet-group']();
    return customAxios.get(api_url);
  },
  getConnectedAccountantGroups: function (params) {
    var api_url = window.Urls['cost-type-group-get-connected-accountant-groups']();
    return customAxios.get(api_url, { params: params });
  }
};

export default CostTypeGroupService;